import React from 'react';
import { logoStyles } from './styles';

/*

Props:

• logoURL
• size
• style

*/

const _applyStyleModifiers = (props) => {
    const { logoURL, size } = props;
    const { avatarLogoStyle } = logoStyles; 
    
    avatarLogoStyle.backgroundImage = (logoURL) ? `url(${logoURL})` : avatarLogoStyle.backgroundImage;

    if (size) {
        avatarLogoStyle.height = avatarLogoStyle.width = size;

        avatarLogoStyle.borderWidth = 1 + (size / 100);

        avatarLogoStyle.borderRadius = size;
    }

    return { avatarLogoStyle };
}

export const Logo = (props) => {
    
    const styles = _applyStyleModifiers(props);

    return (
        <div style={{...styles.avatarLogoStyle, ...props.style }}></div>
    );
};


// WEBPACK FOOTER //
// ./src/js/components/Logo/Logo.jsx